import { useSelector } from 'react-redux';
import { makeFetchEntityByIdSelector } from '../../../selectors/fetch';
import useFetch from '../../../hooks/useFetch';
import Api from '../../../api';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import upperCase from 'lodash/upperCase';

const useSetupServer = () => {
  const { onSubmit, loading: pending } = useFetch(
    'setup-server-save',
    Api.SETUP_SERVER
  );

  const save = (values, onSuccess = () => {}) => {
    onSubmit({
      body: values,
      method: 'PUT',
      onSuccess,
    });
  };

  return {
    pending,
    save,
  };
};

export default useSetupServer;
